import { signIn as cognitoSignIn, signOut, fetchAuthSession, AuthTokens } from "aws-amplify/auth";
import { IAuthService } from "../domain/IAuthService";
import { AuthServiceError, AuthServiceErrors } from "../domain/AuthServiceError";
import { isCognitoError } from "./CognitoError";
import { AuthCredentialsDto } from "common/models/api/models/AuthCredentialsDto";
import { LoginRequest } from "common/models/api/models/LoginRequest";

//TODO: Esta clase acopla directametne funcionalides externas al repositorio por tanto deberia removerse todo tipo de esta clase
export class CognitoService implements IAuthService {
    async signIn(request: LoginRequest): Promise<AuthCredentialsDto> {
        try {
            const response = await cognitoSignIn({
                username: String(request.identifier),
                password: request.password,
            });
            if (response.nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
                throw new AuthServiceError(AuthServiceErrors.CHANGE_PASSWORD);
            }
            const token = await this.getToken();
            return {
                access_token: token,
            };
        } catch (error) {
            if (isCognitoError(error)) {
                switch (error.name) {
                    case "TooManyFailedAttemptsException":
                        throw new AuthServiceError(AuthServiceErrors.TOO_MANY_ATTEMPTS);
                    case "UserDisabledException ":
                        throw new AuthServiceError(AuthServiceErrors.TOO_MANY_ATTEMPTS);
                    default:
                        throw error;
                }
            }
            throw error;
        }
    }
    async signOut(): Promise<void> {
        try {
            await signOut();
        } catch (error) {
            throw error;
        }
    }
    async getToken(): Promise<string> {
        try {
            const session = await fetchAuthSession();
            const token = session.tokens?.accessToken?.toString() || "";
            return token;
        } catch (error) {
            throw error;
        }
    }
    async getSessionTokens(): Promise<AuthTokens | undefined> {
        try {
            const session = await fetchAuthSession();

            return session.tokens;
        } catch (error) {
            throw error;
        }
    }
}
